var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('HeroSection',{attrs:{"id":"hero","small":""}}),_c('GallerySection',{attrs:{"id":"gallery","full":"","year":Number(_vm.$route.params.year)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }